import { AuthProvider } from 'react-oidc-context';
import { oidcConfig } from '../../features/authentication/oidc-config';
import AppLayout from '../app-layout/app-layout.component';

const AuthenticatedAppLayout = () => (
  <AuthProvider {...oidcConfig}>
    <AppLayout />
  </AuthProvider>
);

export default AuthenticatedAppLayout;
